import * as ActionTypes from "../actions/actionTypes";
import initialState from "./initialState";

export default (state = initialState.leads, action) => {
  switch (action.type) {
    case ActionTypes.RECEIVE_LEADS_SNAPSHOT:
      return {
        ...state,
        data: action.leads,
        endBefore: action.endBefore,
        startAfter: action.startAfter
      };
    case ActionTypes.RECEIVE_LEADS_TOTAL_COUNT_SNAPSHOT:
      return { ...state, totalCount: action.totalCount };
    case ActionTypes.SET_LEADS_SEARCH_CRITERIA:
      return { ...state, ...action.searchCriteria };
    case ActionTypes.SET_LEADS_COLUMN_VISIBILITY: {
      return {
        ...state,
        columns: state.columns.map(column => {
          if (column.id === action.column.id) {
            return { ...column, visible: action.column.visible ? false : true };
          }
          return column;
        })
      };
    }
    case ActionTypes.SIGN_OUT_SUCCESS: {
      return initialState.leads;
    }
    default:
      return state;
  }
};
